/* eslint no-console: 0 */
/* eslint camelcase: 0 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from './util/axios';
import { cloneDeep, entries, isEmpty, isEqual, isFunction, isNil, isString, merge } from 'lodash';
import VueRouter from 'vue-router';
// import 'v-calendar/lib/v-calendar.min.css';
import ServiceUrls from '@/lib/ServiceUrls';

import 'core-js/es/array/flat-map';

import Driver from 'driver.js';

import Icons from '@/assets/icons/index';

// import deFieldNames from '@/i18n/de/fields.json';
import HotelmeisterMixin from '../mixins/HotelmeisterMixin';
import { getToken, setToken } from './util/token';
import initWindow from './util/window';
import i18n from './util/i18n';
import store from './util/store';
import initExtend from './util/extend';
import createInstance from './util/instance';
import customizeRouter from './util/router';
import initVue from './util/vue';
import { Axios } from 'axios';
import jwt from 'jsonwebtoken';

/*
axios.defaults.transformRequest = [function (data, headers) {
  headers['x-hotelmeister-auth'] = auth();

  return data;
}];
*/

initWindow();
initExtend();
initVue();

export default function app(name, component, customStore = {}, routes = []) {
  const node = document.querySelector(`*[vue-app=${name}]`);

  if (isNil(node)) {
    return null;
  } else {
    const router = new VueRouter({ routes });
    const serviceBus = new Vue();
    const driver = new Driver({
      animate: true,
      padding: 10,
      closeBtnText: 'Schließen',
      doneBtnText: 'Fertig',
      nextBtnText: 'Weiter',
      prevBtnText: 'Zurück',
      onHighlightStarted: (element) => {
        const elem = element.node;
        if (isFunction(elem.scrollIntoViewIfNeeded)) elem.scrollIntoViewIfNeeded();
        else elem.scrollIntoView();
      },
    });

    axios.$serviceBus = serviceBus;

    Object.defineProperties(Vue.prototype, {
      $serviceUrls: {
        get: function get() {
          return ServiceUrls;
        },
      },
      $serviceBus: {
        get: function get() {
          return serviceBus;
        },
      },
      $driver: {
        get: function get() {
          return driver;
        },
      },
      $jwt: {
        get: function get() {
          return jwt;
        },
      },
    });

    // Basic root instance
    const instance = createInstance(component, name, axios, router);

    /*
    instance.store.subscribe((mutation, state) => {
      const scopedStore = {
        hotel: state.hotel,
        tenant: state.tenant,
      };
      localStorage.setItem('store', isEmpty(scopedStore) ? '' : JSON.stringify(scopedStore));
    });
     */

    window.vueActive = true;

    const $vm = new Vue(instance).$mount(node);

    customizeRouter($vm, router);

    window.HmVue.instances[name] = $vm;

    return $vm;
  }
}



// WEBPACK FOOTER //
// ./src/lib/app.js